import React from "react";
import "./WhatsAppPopup.scss";
import { Form, Input, Button } from "semantic-ui-react";
import TwilioService from "../../services/twilioService";
import toastr from "toastr";
import { createZendeskIdValidator } from "../../utils/useZendeskIdValidator";

class WhatsAppPopup extends React.Component {
  constructor(props) {
    super(props);
    const { phoneNumber = "", zendeskId = "" } = props;
    this.state = {
      phoneNumber: phoneNumber,
      zendeskID: zendeskId,
      message: "",
      errorPhoneNumber: false,
      errorMessage: false,
      errorZendeskID: false,
      existZendeskID: !!zendeskId,
      existApplicant: !!zendeskId,
      zendeskIDStatus: zendeskId ? "check" : "",
      sending: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    const { onSearch$, cleanup } = createZendeskIdValidator(this);
    this.onSearch$ = onSearch$;
    this.cleanupValidator = cleanup;
    if (this.props.zendeskId) {
      this.onSearch$.next(this.props.zendeskId);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.cleanupValidator) {
      this.cleanupValidator();
    }
  }

  async sendMessage(event) {
    event.stopPropagation();
    const { phoneNumber, message, zendeskID, existZendeskID } = this.state;
    if (!phoneNumber || !phoneNumber.trim()) {
      this.setState({ errorPhoneNumber: true });
      toastr.error("Phone number is required.", "Error");
      return;
    }
    if (!message || !message.trim()) {
      this.setState({ errorMessage: true });
      return;
    }
    const isZendeskLoading = this.state.zendeskIDStatus === "loading";
    if (isZendeskLoading) {
      toastr.warning("Zendesk ID is still being verified. Please wait.", "Warning");
      return;
    }
    if (!zendeskID || !existZendeskID) {
      this.setState({ errorZendeskID: true });
      toastr.error("Valid Zendesk ID is required.", "Error");
      return;
    }
    this.setState({ sending: true });
    try {
      await TwilioService.sendWhatsApp(phoneNumber, message, {
        applicantId: this.props.applicantId,
        zendeskId: zendeskID,
        product: this.props.product,
      });
      toastr.success("WhatsApp message sent successfully.");
      this.props.closeModal();
    } catch (error) {
      // Error toasts are handled by TwilioService.sendWhatsApp
      if (this._isMounted) {
        this.setState({ sending: false });
      }
    }
  }

  phoneNumberChanged(value) {
    if (/^\+?[0-9 ]*$/.test(value)) {
      this.setState({
        phoneNumber: value.replace(/ {2}/, " "),
        errorPhoneNumber: value ? false : this.state.errorPhoneNumber,
      });
    }
  }

  messageChanged(value) {
    this.setState({
      message: value,
      errorMessage: value ? false : this.state.errorMessage,
    });
  }

  renderWhatsAppPopup() {
    const { phoneNumber, message } = this.state;

    return (
      <div className="sk-whatsapp-popup-container">
        <Form className="sk-whatsapp-popup-form">
          <div className="sk-dial-pad-input-numbers">
            <Input
              name="phoneNumber"
              value={phoneNumber}
              onChange={(event) => {
                this.phoneNumberChanged(event.target.value);
              }}
              type="tel"
              label="Phone number:"
              size="small"
              error={this.state.errorPhoneNumber}
            ></Input>
            <Input
              icon={this.state.zendeskIDStatus === "check" || this.state.zendeskIDStatus === "delete"
                ? this.state.zendeskIDStatus
                : ""}
              loading={this.state.zendeskIDStatus === "loading"}
              name="zendeskID"
              value={this.state.zendeskID}
              onChange={(event) => {
                this.onSearch$.next(event.target.value);
                if (event.target.value) {
                  this.setState({ errorZendeskID: false });
                }
              }}
              label="Zendesk ID: "
              size="small"
              error={this.state.errorZendeskID}
            ></Input>
          </div>
          <div className="sk-whatsapp-popup-textarea-container">
            <Form.TextArea
              value={message}
              onChange={(event) => this.messageChanged(event.target.value)}
              rows={10}
              placeholder="WhatsApp message"
              error={this.state.errorMessage}
            ></Form.TextArea>
          </div>

          <div className="sk-whatsapp-button-group">
            <Button
              className="sk-whatsapp-send-button"
              onClick={(event) => this.sendMessage(event)}
              disabled={this.state.sending}
              loading={this.state.sending}
            >
              Send
            </Button>
            <Button
              className="sk-whatsapp-cancel-button"
              onClick={() => this.props.closeModal()}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  render() {
    return (
      <div className="sk-whatsapp-popup-modal">{this.renderWhatsAppPopup()}</div>
    );
  }
}

export default WhatsAppPopup;
